import * as React from 'react';

export interface IOfferFactsInSidebarProps {
  children: React.ReactNode;
}

export const OfferFactsInSidebar: React.FC<IOfferFactsInSidebarProps> = ({ children }) => {
  return <div>{children}</div>;
};
